import { useMemo } from 'react';

import { CopyEntityID, CopyEntityResponse } from '@playq/octopus2-creatives';
import { GenericFailure } from '@playq/services-shared';

import { useEitherQuery, IUseQueryOptionsExtended } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { retrieveCopyTags } from './constants';

export const useCopyRetrieve = (
  id?: CopyEntityID,
  options?: IUseQueryOptionsExtended<CopyEntityResponse | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => retrieveCopyTags.concat(id), [id]);

  const res = useEitherQuery(keys, () => services2.copiesService.retrieve(id as CopyEntityID), {
    ...options,
    enabled: options?.enabled !== false && id !== undefined,
  });

  return {
    ...res,
    tags: keys,
  };
};
